import './Input.css';
import { useState } from 'react';
import { Upload, Flex, Typography } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';

const Input = ({ onSendMessage, attachments = [], onFileChange, isChatMode = false }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  const handleSendClick = () => {
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  const handleFileChange = (info) => {
    if (onFileChange) {
      onFileChange(info.fileList);
    }
  };

  return (
    <div className="input-wrapper">
      <form className="input-container" onSubmit={handleSubmit}>
        <input
          type="text"
          className="input-field"
          placeholder="Опишите кратко суть проблемы"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <div className="input-buttons">
          <Upload
            name="files"
            beforeUpload={() => false}
            multiple
            showUploadList={false}
            onChange={handleFileChange}
            fileList={attachments}
          >
            <button type="button" className="upload-button" title="Загрузить файл">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
              </svg>
            </button>
          </Upload>
          <button
            type="submit"
            className="send-button"
            title="Отправить"
            onClick={handleSendClick}
            disabled={!message.trim()}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default Input;
